import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';

@Component({
    selector: 'app-gdo-desktop',
    templateUrl: './gdo-desktop.component.html',
    styleUrls: ['./gdo-desktop.component.scss'],
    standalone: false
})
export class GdoDesktopComponent implements OnInit {

  constructor(private _appService:AppService) { }

  ngOnInit(): void {
  this._appService.setViewViewStatus(false)
  this._appService.setLeftMenuVisibilityStatus(true)
  this._appService.setIsGdoPortal(true)
  document.body.classList.remove('dark-theme');
  document.body.classList.add('light-theme');
  }

}
